import React from 'react';
import PropTypes from 'prop-types';

import {
	CheckboxIndeterminateIcon,
	CheckboxUncheckedIcon,
} from 'components/icons';

import { Wrapper, StyledCheckboxCheckedIcon } from './styles';

const Checkbox = ({ checked, indeterminate, onChange, className }) => (
	<Wrapper
		className={className}
		onClick={onChange}
		role="checkbox"
		tabIndex={0}
		aria-checked={checked}
	>
		{indeterminate ? <CheckboxIndeterminateIcon /> : null}
		{!indeterminate && checked ? <StyledCheckboxCheckedIcon /> : null}
		{!indeterminate && !checked ? <CheckboxUncheckedIcon /> : null}
	</Wrapper>
);

export default Checkbox;

Checkbox.propTypes = {
	checked: PropTypes.bool,
	indeterminate: PropTypes.bool,
	onChange: PropTypes.func,
	className: PropTypes.string,
};

Checkbox.defaultProps = {
	checked: false,
	indeterminate: false,
	onChange: () => {},
	className: '',
};
